/**
 *
 * InvalidEmailModal
 *
 */

import React from 'react';
import {
  ContentWrapper,
  IconWrapper,
  Text,
} from './styledComponents';

import Icon from 'components/Icon';
import Modal from 'components/Modal';
import H1 from 'components/H1';

const InvalidEmailModal = ({ close }) => (
  <Modal shakeOnOpen close={close} title='Invalid Email'>
    <ContentWrapper>
      <IconWrapper>
        <Icon name='wrong-email' size={102} fill={"#E1143E"} />
      </IconWrapper>
      <H1>
        That email legit?
      </H1>
      <Text>
        The email address you entered doesn’t seem to be a valid.
        Would you please double check for typos and try again?
      </Text>
    </ContentWrapper>
  </Modal>
);

export default InvalidEmailModal;



// WEBPACK FOOTER //
// ./src/components/InvalidEmailModal/index.js